export default {
  title: 'Programa de avaliações do Google',
  sections: {
    google_review_settings: 'Definições do programa de avaliações do Google',
  },
  form: {
    reward: {
      label: 'Recompensa (pontos)',
      point_value: '100 pontos = {{moneyValue}}',
    },
    has_end_date: {
      label: 'Duração',
      options: {
        false: 'Infinito',
        true: 'Com data de fim específica',
      },
    },
    end_date: {
      label: 'Data de fim',
    },
  },
  tags: {
    inactive: 'Inativo',
    active: 'Ativo',
    expired: 'Expirado',
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar os dados',
    changes_got_saved: 'Alterações guardadas',
    failed_to_save_changes: 'Falha ao guardar as alterações',
  },
};
